import React from 'react';

const Home: React.FC = () => {
  return (
    <div>
      <div className="hero">
        <div className="hero-content">
          <h1>Welcome to TMD: Total Market Dominance</h1>
          <p>Your Trusted Partner in Algorithmic Trading</p>
          <button className="btn btn-primary hero-button" >
            Get Started
          </button>
        </div>
      </div>

      <div className="container">
        <div className="grid">
          <div className="card">
            <h3>What is Forex Trading?</h3>
            <p>
              Forex trading is the act of buying and selling currencies with the aim of making a profit.
              It's the largest and most liquid financial market in the world, with approx 6-7 trillion dollars
              being traded daily.
            </p>
          </div>
          <div className="card">
            <h3>Why Choose Our Expert Advisor?</h3>
            <p>
              Our Expert Advisor is designed to help you navigate the forex market with advanced
              algorithms and proven strategies. It provides automated trading solutions with
              customizable parameters to suit your trading style.
            </p>
          </div>
        </div>

        <div className="text-center section-title">
          <h2>Why Choose Us?</h2>
        </div>
        <div className="grid">
          {[
            {
              title: 'Proven Track Record',
              description: 'Our Expert Advisors have been tested and proven in real market conditions',
              icon: '/images/track-record.jpg'
            },
            {
              title: 'Advanced Technology',
              description: 'State-of-the-art algorithms and machine learning capabilities',
              icon: '/images/technology.jpg'
            },
            {
              title: '24/7 Support',
              description: 'Round-the-clock technical support and assistance',
              icon: '/images/support.jpg'
            }
          ].map((feature, index) => (
            <div className="feature-card" key={index}>
              <img src={feature.icon} alt={feature.title} />
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home; 